import {
  Tooltip,
  TooltipProps,
  Text,
  Icon,
  Box,
  IconName,
  ColorProps,
  useDisclosure,
  useOutsideClick,
} from '@wegroup/design-system';
import React from 'react';

interface Props {
  label: string | React.ReactElement;
  iconName?: IconName;
  boxSize?: number;
  color?: ColorProps['color'];
}

const InfoTooltip: React.FC<Props & Omit<TooltipProps, 'children'>> = ({
  label,
  iconName = 'GeneralActionsQuestion',
  boxSize = 7,
  color,
  placement,
  ...tooltipProps
}) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const ref = React.useRef<HTMLDivElement>(null);

  // Close when user taps/clicks outside
  useOutsideClick({ ref, handler: onClose });

  const handlePointerDown = (e: React.PointerEvent) => {
    if (e.pointerType === 'mouse') return; // hover will handle it
    onToggle();
    e.stopPropagation();
  };

  return (
    <Tooltip
      label={<Text>{label}</Text>}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      placement={placement}
      closeOnClick={false}
      {...tooltipProps}
    >
      <Box
        ref={ref}
        cursor="pointer"
        onPointerDown={handlePointerDown}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
      >
        <Icon name={iconName} boxSize={boxSize} color={color} />
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;
